import {
	FETCH_STATSV2_COCKPIT_BEGIN,
	FETCH_STATSV2_COCKPIT_SUCCESS,
	FETCH_STATSV2_COCKPIT_ERROR,
	FETCH_STATSV2_TENDANCES_BEGIN,
	FETCH_STATSV2_TENDANCES_SUCCESS,
	FETCH_STATSV2_TENDANCES_ERROR,
} from "../actions/statsV2Actions"

const initialState = {
	cockpit: null,
	tendances: null,
	fetchCockpit: { loading: false, error: false },
	fetchTendances: { loading: false, error: false },
}

export default function statsV2Reducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_STATSV2_COCKPIT_BEGIN:
			return { ...state, fetchCockpit: { loading: true, error: false } }
		case FETCH_STATSV2_COCKPIT_SUCCESS:
			return {
				...state,
				cockpit: action.payload.cockpit,
				fetchCockpit: { loading: false, error: false },
			}
		case FETCH_STATSV2_COCKPIT_ERROR:
			return {
				...state,
				fetchCockpit: { loading: false, error: action.payload.error },
			}
		case FETCH_STATSV2_TENDANCES_BEGIN:
			return { ...state, fetchTendances: { loading: true, error: false } }
		case FETCH_STATSV2_TENDANCES_SUCCESS:
			return {
				...state,
				tendances: action.payload.tendances,
				fetchTendances: { loading: false, error: false },
			}
		case FETCH_STATSV2_TENDANCES_ERROR:
			return {
				...state,
				fetchTendances: { loading: false, error: action.payload.error },
			}
		default:
			return state
	}
}
